import { useQuery } from '@tanstack/react-query';

import type { VersionResponse } from '@platform/contracts';

/** This bundle's own identity, inlined at build time (MASTER_PLAN M0.7). */
export const APP_BUILD: VersionResponse = {
  version: __APP_VERSION__,
  commit: __APP_COMMIT__,
  builtAt: __BUILT_AT__,
};

const API_BASE = import.meta.env.VITE_API_BASE ?? '/api/v1';

/**
 * Reads the API's build identity so the footer can show a mismatch after a partial
 * deploy. A failure is not an error state for the user: the footer simply shows the
 * app build alone.
 * TODO(M2.10): replace the hand-written fetch with the generated typed client.
 */
export function useApiVersion(): VersionResponse | undefined {
  const query = useQuery({
    queryKey: ['api-version'],
    staleTime: Infinity,
    retry: false,
    queryFn: async (): Promise<VersionResponse> => {
      const response = await fetch(`${API_BASE}/version`, {
        headers: { accept: 'application/json' },
      });
      if (!response.ok) {
        throw new Error(`GET ${API_BASE}/version responded ${String(response.status)}`);
      }
      return (await response.json()) as VersionResponse;
    },
  });

  return query.data;
}
